import React from 'react'
import { OverlayDiv } from './index.styled'

const Overlay = ({ light = false }) => {
  return <OverlayDiv className={light && 'light'} />
}
export default Overlay
